import ErrMessage from "../../core/ErrMessage.tsx";
import { useExistingChat } from "../../../fetch/fetch.chat.ts";
import { ReactNode } from "react";
import { ChatType } from "../../../types/Chat.ts";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle.tsx";

const ExistingChat = ({
  children,
  itemId,
  ifNoChat = null,
}: {
  children: (chat: ChatType) => ReactNode;
  ifNoChat?: ReactNode;
  itemId: string;
}) => {
  const { chat, isLoading, isError } = useExistingChat(itemId);
  if (isLoading) return LOADING_CIRCLE;
  if (isError) return <ErrMessage message={isError.message} />;
  if (!chat || chat === "NO CHAT") return ifNoChat;
  return children(chat);
};
export default ExistingChat;
